import { render, staticRenderFns } from "./movement-totals.vue?vue&type=template&id=01b3fe3b&scoped=true"
import script from "./movement-totals.vue?vue&type=script&lang=js"
export * from "./movement-totals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01b3fe3b",
  null
  
)

export default component.exports